/**============================================================
* [BlogArchiveMore]
* description : もっと見るブロック
============================================================*/
export default class BlogArchiveMore {
  constructor(target) {
    this.target = target;
    this.moreNumber = 9;
    this.pageTotalCnt = Math.ceil(Array.from(this.target.querySelectorAll('.js-archive-more__item')).length / 9);
    this.pageCurrentCnt = 1;
    this.button = document.querySelector('.js-archive-more-button');
    this.buttonAll = document.querySelector('.js-archive-all-button');

    /* 初期設定(表示リスト以外は非表示にする) */
    this.target.querySelectorAll('.js-archive-more__item:nth-child(n + ' + (this.moreNumber + 1) + ')')
      .forEach((elem)=>{
        elem.classList.add('is-first-hidden');
      })

    /* 全リスト表示時「もっとみる」ボタンをフェードアウト */
    this.button.addEventListener(
      'click',
      e => {
        e.stopImmediatePropagation();
        Array.from(this.target.querySelectorAll('.js-archive-more__item.is-first-hidden:not(.is-show)')).slice(0, this.moreNumber)
          .forEach((elem)=>{
            elem.classList.add('is-show');
          })
        this.pageCurrentCnt++;
        if(this.pageCurrentCnt === this.pageTotalCnt) {
          this.button.classList.add('is-hidden');
          this.buttonAll.classList.add('is-visible');
        }
      },
      false
    )

    /* リスト数が表示リスト数以下の時は「もっとみる」ボタンは非表示 */
    const list = this.target.querySelectorAll('.js-archive-more__item').length;
    if (list <= this.moreNumber) {
      this.button.classList.add('is-hidden');
    }

  }
}
